import styled from "styled-components";
import { MEDIA_MOBILE_BREAKPOINT } from "src/apps/config/constants";
import { useIsMedia } from "src/apps/hooks/useIsMedia";
import { OrderPayslip } from "src/contexts/documentationArea/domain/OrderPayslip";
import { OrderBox } from "../components/orderBox/OrderBox";

interface PayslipsContentProps {
  payslips: OrderPayslip[];
}

export const PayslipsContent = ({ payslips }: PayslipsContentProps) => {
  const { isMobile } = useIsMedia();
  return (
    <Container $isMobile={isMobile}>
      {payslips.map((order) => {
        return (
          <OrderBoxContainer key={order.getId()}>
            <OrderBox order={order} />
          </OrderBoxContainer>
        );
      })}
    </Container>
  );
};

const OrderBoxContainer = styled.div`
  align-self: stretch;
`;

const Container = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.75rem;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    padding: 0rem;
    padding-top: 1rem;
    gap: 1rem;
  }
  align-items: stretch;
`;
